import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';
import { combineLatest, merge, Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerAccountOverviewModalComponent } from '../../shared/customer-account-overview-modal/customer-account-overview-modal.component';
import { CustomerPaymentModalComponent } from '../../shared/customer-payment-modal/customer-payment-modal.component';
import { normalizeSalesmanAllowed } from '../../classes/default-salesman-allowed';
@Component({
	selector: 'app-over-due-customers',
	templateUrl: './over-due-customers.component.html',
	styleUrls: ['./over-due-customers.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  state('orderlookup', style({
			  transform: 'rotateY(170deg)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
		  transition('inactive => orderlookup', animate('500ms ease-out')),
		  transition('orderlookup => inactive', animate('500ms ease-in')),
	  ]),
	 trigger('openClose', [
		  state(':enter', style({ height: '*' })),
		  state(':leave', style({ height: '0px' })),
		  transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
	  transition(':enter, * => 0, * => -1', []),
	  transition(':increment', [
				query(':enter', [
		  style({ opacity: 0, width: 0 }),
		  stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
		  ]),
				], { optional: true })
	  ]),
	  transition(':decrement', [
				query(':leave', [
		  stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
		  ]),
				])
	  ]),
		]),
		trigger('grow', [
	  transition(':enter', [
				style({ height: '0',width: '0' }),
				animate(200, style({ height: '*' , width: '*' })),
				animate('200ms', style({ opacity: 1 })),
	  ]),
	  transition(':leave', [
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 }))
	  ])
		]),
	]
})
export class OverDueCustomersComponent implements OnInit, OnDestroy {
	@Input() flip = 'inactive';
	@Output() viewData = new EventEmitter < any > ();

	trialbalance: any = [];
	isTrialBalanceLoading = true;
	overdueone: any = false;
	overduetwo: any = false;
	overduethree: any = false;
	overduezero: any = false;
	original_trialbalance: any = false;


	total_overdue_details = {
		zero: 0,
		one: 0,
		two: 0,
		three: 0,
		total: 0,
	}

	viewing: any = false;
	title: any = '';
	/** When the detail panel is open, which slice title — used to re-bind data after refresh. */
	private reportDetailTitle: string | null = null;
	/** Full salesman catalog from API (for trial-balance filters). */
	trialBalanceSalesmen: { code: string; name: string }[] = [];

	/** Same rules as customer view Payment tab: full users yes; salesmen from `salesmanAllowed.takepayment`. */
	takepaymentAllowed = true;

	private readonly destroy$ = new Subject<void>();

	constructor(
		private customerService: CustomerService,
		private globalSearchService: GlobalSearchService,
		private modalService: NgbModal,
	) {}

	ngOnInit(): void {
		this.loadTrialBalance(false);

		combineLatest([
			this.globalSearchService.configsubscription,
			this.globalSearchService.user,
		])
			.pipe(
				takeUntil(this.destroy$),
				filter(([cfg, u]) => cfg != null && u != null),
				map(([cfg, u]) => (u?.user?.issalesman ? normalizeSalesmanAllowed(cfg?.salesmanAllowed).takepayment : true)),
			)
			.subscribe((allowed) => {
				this.takepaymentAllowed = allowed;
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	/** Re-fetch trial balance from the server (optional cache bust). Call from Refresh UI. */
	refreshReport(): void {
		if (this.isTrialBalanceLoading) {
			return;
		}
		this.loadTrialBalance(true);
	}

	private loadTrialBalance(bustCache: boolean): void {
		this.isTrialBalanceLoading = true;
		this.customerService.getTrialBalance(bustCache).subscribe({
			next: (results: any) => {
				let arr: any[] = [];
				let salesmen: { code: string; name: string }[] = [];
				if (results && typeof results === 'object' && !Array.isArray(results) && Array.isArray(results.customers)) {
					arr = results.customers;
					if (Array.isArray(results.salesmen)) {
						salesmen = results.salesmen
							.map((s: any) => ({
								code: s?.code != null ? String(s.code).trim() : '',
								name: s?.name != null ? String(s.name).trim() : '',
							}))
							.filter((s: { code: string; name: string }) => s.code !== '');
					}
				} else {
					arr = (Array.isArray(results) && results)
						|| (results?.data && Array.isArray(results.data) && results.data)
						|| (results?.customers && Array.isArray(results.customers) && results.customers)
						|| [];
				}
				this.trialBalanceSalesmen = salesmen;
				if (arr.length === 0 && results) {
					this.trialbalance = [];
				}
				this.trialbalance = arr;
				this.original_trialbalance = arr;

				this.overdueone = this.trialbalance.filter((customer: any) => {
					const add_customer_bucket1 = parseFloat(customer.overdue) > 0.0000 ? 1 : 0;
					return parseFloat(customer.overdue) > 0.0000 ? true : false;
				});

				this.overduetwo = this.trialbalance.filter((customer: any) => {
					return parseFloat(customer.overdue1) > 0.0000 ? true : false;
				});

				this.overduethree = this.trialbalance.filter((customer: any) => {
					return parseFloat(customer.overdue2) > 0.0000 ? true : false;
				});

				this.overduezero =  this.trialbalance.filter((customer: any) => {
					return parseFloat(customer.due) > 0.0000 ? true : false;
				});

				if (Array.isArray(this.trialbalance)) {
					this.total_overdue_details.zero = this.trialbalance.reduce(function(accumulator, customer) {
						const add_customer_bucket1 = parseFloat(customer.due) > 0.0000 ? 1 : 0;
						return accumulator + add_customer_bucket1;
					}, 0);

					this.total_overdue_details.one = this.trialbalance.reduce(function(accumulator, customer) {
						let addon = 0;
						if(parseFloat(customer.overdue) > 0.0000 && !(parseFloat(customer.overdue1) > 0.0000)) {
							addon = 1;
						}
						return accumulator + addon;
					}, 0);

					this.total_overdue_details.two = this.trialbalance.reduce(function(accumulator, customer) {
						let add_customer_bucket2 = 0;
						add_customer_bucket2 = parseFloat(customer.overdue1) > 0.0000 ? 1 : 0;
						return accumulator + add_customer_bucket2;
					}, 0);

					this.total_overdue_details.three = this.trialbalance.reduce(function(accumulator, customer) {
						let add_customer_bucket3 = 0;
						add_customer_bucket3 = parseFloat(customer.overdue2) > 0.0000 ? 1 : 0;
						return accumulator + add_customer_bucket3;
					}, 0);
				} else {
					this.total_overdue_details.zero = 0;
					this.total_overdue_details.one = 0;
					this.total_overdue_details.two = 0;
					this.total_overdue_details.three = 0;
				}

				this.total_overdue_details.total = Array.isArray(this.trialbalance)
					? this.trialbalance.filter((customer: any) => {
						const d = parseFloat(customer?.due) || 0;
						const o = parseFloat(customer?.overdue) || 0;
						const o1 = parseFloat(customer?.overdue1) || 0;
						const o2 = parseFloat(customer?.overdue2) || 0;
						return d > 0.0001 || o > 0.0001 || o1 > 0.0001 || o2 > 0.0001;
					}).length
					: 0;
				this.isTrialBalanceLoading = false;
				this.syncViewingAfterLoad();
			},
			error: (error) => {
				console.error('Failed to load trial balance:', error);
				this.trialbalance = [];
				this.original_trialbalance = [];
				this.trialBalanceSalesmen = [];
				this.isTrialBalanceLoading = false;
			}
		});
	}

	/** If the user has the detail grid open, point `viewing` at the new array for the same age bucket. */
	private syncViewingAfterLoad(): void {
		if (this.flip !== 'active' || !this.reportDetailTitle) {
			return;
		}
		const t = this.reportDetailTitle;
		if (t === 'All') {
			this.viewing = this.original_trialbalance;
		} else if (t === '30 Days') {
			this.viewing = this.overduezero;
		} else if (t === '60 Days') {
			this.viewing = this.overdueone;
		} else if (t === '90 Days') {
			this.viewing = this.overduetwo;
		} else if (t === '120 Days') {
			this.viewing = this.overduethree;
		}
	}

	openCustomerAccountOverview(payload: { debtorno: string; branchcode: string; title: string }): void {
		if (!payload?.debtorno?.trim() || !payload?.branchcode?.trim()) {
			return;
		}
		const ref = this.modalService.open(CustomerAccountOverviewModalComponent, {
			size: 'xl',
			scrollable: true,
			windowClass: 'ca-overview-modal-window',
		});
		ref.componentInstance.debtorno = payload.debtorno.trim();
		ref.componentInstance.branchcode = payload.branchcode.trim();
		ref.componentInstance.customerTitle = payload.title || `${payload.debtorno}.${payload.branchcode}`;
	}

	openCustomerPayment(payload: { debtorno: string; branchcode: string; title: string }): void {
		if (!payload?.debtorno?.trim() || !payload?.branchcode?.trim()) {
			return;
		}
		const ref = this.modalService.open(CustomerPaymentModalComponent, {
			size: 'xl',
			scrollable: true,
			windowClass: 'cp-payment-modal-window',
		});
		ref.componentInstance.debtorno = payload.debtorno.trim();
		ref.componentInstance.branchcode = payload.branchcode.trim();
		ref.componentInstance.customerTitle = payload.title || `${payload.debtorno}.${payload.branchcode}`;
		merge(ref.closed, ref.dismissed)
			.pipe(take(1), takeUntil(this.destroy$))
			.subscribe(() => {
				this.refreshReport();
			});
	}

	toggleFlip(data: any, title: string) {

		if(!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			this.reportDetailTitle = title;
			const dashboard_data = { data: data, title: 'agedc' }
			this.viewData.emit(dashboard_data);
		} else {
			this.reportDetailTitle = null;
			this.viewData.emit(false);
		}
	}

}
